import {
  DeletePayload,
  PostPayload,
  PutPayload,
} from "../../../../model/http-crud-models";
import { OrganizationKeyName } from "../../../../model/Organization";
import { httpClient } from "../../../../service/http";
import {
  AutoCampaign,
  AutoCampaignListItem,
  AutoCampaignMutationPayload,
} from "../models/AutoCampaign";

export const campaignHttp = {
  getCampaigns: async (organizationKeyName?: OrganizationKeyName) => {
    return httpClient<AutoCampaignListItem[]>({
      method: "GET",
      url: `/organizations/${organizationKeyName}/campaigns`,
    });
  },

  getCampaign: async (
    organizationKeyName?: OrganizationKeyName,
    id?: string
  ) => {
    return httpClient<AutoCampaign>({
      method: "GET",
      url: `/organizations/${organizationKeyName}/campaigns/${id}`,
    });
  },

  deleteCampaign: async ({
    data: { id },
    organizationKeyName,
  }: DeletePayload) => {
    return httpClient({
      method: "DELETE",
      url: `/organizations/${organizationKeyName}/campaigns/${id}`,
    });
  },

  createCampaign: async ({
    data,
    organizationKeyName,
  }: PostPayload<AutoCampaignMutationPayload>) => {
    return httpClient({
      method: "POST",
      url: `/organizations/${organizationKeyName}/campaigns`,
      data,
    });
  },

  updateCampaign: async ({
    data: { id, ...rest },
    organizationKeyName,
  }: PutPayload<AutoCampaignMutationPayload>) => {
    return httpClient({
      method: "PUT",
      url: `/organizations/${organizationKeyName}/campaigns/${id}`,
      data: rest,
    });
  },
};
